var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KDraggableField',{staticClass:"input-container",attrs:{"allowedFormats":['pdf', 'xml']},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('md-avatar',{staticClass:"md-avatar-icon md-primary"},[_c('md-icon',[_vm._v("attachment")])],1),_vm._v(" "),_c('p',{staticClass:"input-text"},[_vm._v(_vm._s(_vm.uploadLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Inputs/FileByTypeLoader.vue